import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { COLOR_GREY_4 } from "shared/theme/colors";
import { flex } from "shared/theme/mixins";

export const StyledUserDetailsContainer = styled(Box)`
  ${flex({ fd: "column" })};
  row-gap: 1.5rem;
  width: 280px;
  padding: 1.5rem;
`;

export const StyledSeparator = styled(Box)`
  ${flex({ ai: "center", jc: "space-between" })};
  width: 100%;
  height: 1px;
  background-color: ${COLOR_GREY_4};
`;
